// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"SearchUnitRooms__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/SearchUnitRooms/SearchUnitRooms.scss
 ** module id = 941
 ** module chunks = 1
 **/